import React from "react";
import { Toaster } from "react-hot-toast";

/** App-level toast host shared by standalone and embedded questionnaire entrypoints. */
export default function QuestionnaireToastHost() {
  return (
    <Toaster
      position="top-center"
      containerStyle={{ zIndex: 10000 }}
      toastOptions={{ duration: 4000 }}
    />
  );
}
